/**
 * Cookie-consent storage. Client-side only — reads/writes the consent
 * cookie. Ported from psoodle-stack's utils/consent.
 *
 * ponytail: cookie persistence only. DB audit logging (psoodle's
 * legal.saveCookieConsent) plugs in here once the legal schema lands from
 * the psoodle schema port.
 */

export interface ConsentCookie {
  v: string;
  analytics: boolean;
}

export const CONSENT_COOKIE_NAME = "filium_consent";
export const CONSENT_VERSION = "1.0";
export const CONSENT_COOKIE_DAYS = 365;

export function getCookie(name: string): string | undefined {
  if (typeof document === "undefined") return undefined;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : undefined;
}

export function setCookie(name: string, value: string, days: number) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const secure =
    typeof window !== "undefined" && window.location.protocol === "https:"
      ? ";Secure"
      : "";
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/;SameSite=Lax${secure}`;
}

export function getConsentCookie(): ConsentCookie | null {
  const raw = getCookie(CONSENT_COOKIE_NAME);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as ConsentCookie;
    return typeof parsed.analytics === "boolean" ? parsed : null;
  } catch {
    return null;
  }
}

export function setConsentCookie(analytics: boolean) {
  const value: ConsentCookie = { v: CONSENT_VERSION, analytics };
  setCookie(CONSENT_COOKIE_NAME, JSON.stringify(value), CONSENT_COOKIE_DAYS);
}
